import { render, staticRenderFns } from "./listEvents.vue?vue&type=template&id=ca4db310&scoped=true"
import script from "./listEvents.vue?vue&type=script&lang=js"
export * from "./listEvents.vue?vue&type=script&lang=js"
import style0 from "./listEvents.vue?vue&type=style&index=0&id=ca4db310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4db310",
  null
  
)

export default component.exports